<template>

    <form class="p-reset" @submit.prevent="validateForm('reset-password-form')" data-vv-scope="reset-password-form">
        <h2 class="p-reset__title">Zresetuj hasło</h2>
        <form-desc>Podaj adres e-mail, na który wyślemy link do zresetowania hasła</form-desc>
        <form-input
            v-model="email"
            label="Email"
            v-validate.disable="'required|email'">
        </form-input>

        <form-row align="center">
            <v-btn
                class="p-reset__btn"
                :loading="isLoading"
                has-loader
                role="submit"
                type="green">
                Zresetuj hasło
            </v-btn>
        </form-row>
        <form-desc class="p-reset__back">
            <router-link :to="{ name: 'Login' }">Wróć do logowania</router-link>
        </form-desc>
        <p class="p-reset__tip" :class="{ 'p-reset__tip--shown' : sent }">
            <span class="p-reset__tip-title">Link do zresetowania hasła został wysłany</span>
            <span>Sprawdź skrzynkę mailową</span>
        </p>
    </form>

</template>


<script>

import {FormInput, FormRow, FormDesc} from 'Components/Form'
import VBtn from 'Components/VBtn'

export default {

    name: 'ViewResetPassword',

    data() {
        return {
            email: this.$route.query.email || '',
            isLoading: false,
            sent: false
        }
    },

    methods: {
        validateForm(scope) {
            this.isLoading = true

            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.$store.dispatch('PHT_PASSWORD_RESET', {
                        email: this.email
                    }).then(() => {
                        this.isLoading = false
                        this.sent = true
                    }).catch((e) => {
                        this.$alert.error('Resetowanie hasła', e.response.data.message)
                        this.isLoading = false
                    })
                } else {
                    this.isLoading = false
                }
            })
        }
    },

    components: {
        FormInput,
        FormRow,
        FormDesc,
        VBtn,
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-reset {
    position: relative;

    &__title {
        margin-bottom: 25px;
    }
    &__btn a {
        font-size: 16px;
    }
    &__back {
        margin: 0;
        margin-top: 2em;
        text-align: center;
    }
    &__tip {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-direction: column;
        font-size: 1em;
        background-color: $c-white;
        color: $c-third;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        visibility: hidden;
        transition: opacity .5s ease-in-out, visibility 0s .5s linear;

        &-title {
            font-size: 1.5em;
            margin-bottom: 1em;
        }
        &--shown {
            transition-delay: 0s;
            opacity: 1;
            visibility: visible;
        }
    }
}

</style>
